var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaneSwimming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.333 133H133C123.808 133 115.76 127.56 114 120.333C112.239 127.56 104.192 133 94.9998 133C85.8076 133 77.7605 127.56 75.9998 120.333C74.2392 127.56 66.192 133 56.9998 133C47.8078 133 39.7602 127.56 37.9998 120.333C36.2394 127.56 28.1918 133 18.9998 133H12.6665",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.333 133H133C123.808 133 115.76 127.56 114 120.333C112.239 127.56 104.192 133 94.9998 133C85.8076 133 77.7605 127.56 75.9998 120.333C74.2392 127.56 66.192 133 56.9998 133C47.8078 133 39.7602 127.56 37.9998 120.333C36.2394 127.56 28.1918 133 18.9998 133H12.6665",
    stroke: "url(#paint0_linear_16725_946)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.333 19L118.656 19.5592C110.296 22.346 106.115 23.7394 103.724 27.0566C101.333 30.3738 101.333 34.7801 101.333 43.5926V107.667",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.333 19L118.656 19.5592C110.296 22.346 106.115 23.7394 103.724 27.0566C101.333 30.3738 101.333 34.7801 101.333 43.5926V107.667",
    stroke: "url(#paint1_linear_16725_946)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6665 19L67.9888 19.5592C59.6285 22.346 55.4484 23.7394 53.0575 27.0566C50.6665 30.3738 50.6665 34.7801 50.6665 43.5926V107.667",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6665 19L67.9888 19.5592C59.6285 22.346 55.4484 23.7394 53.0575 27.0566C50.6665 30.3738 50.6665 34.7801 50.6665 43.5926V107.667",
    stroke: "url(#paint2_linear_16725_946)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6665 44.3333H101.333M50.6665 69.6666H101.333M50.6665 94.9999H101.333",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6665 44.3333H101.333M50.6665 69.6666H101.333M50.6665 94.9999H101.333",
    stroke: "url(#paint3_linear_16725_946)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_946",
    x1: 12.6665,
    y1: 120.333,
    x2: 30.5289,
    y2: 171.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_946",
    x1: 101.333,
    y1: 19,
    x2: 125.654,
    y2: 20.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_946",
    x1: 50.6665,
    y1: 19,
    x2: 74.987,
    y2: 20.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_946",
    x1: 50.6665,
    y1: 44.3333,
    x2: 110.879,
    y2: 61.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaneSwimming);
export default __webpack_public_path__ + "static/media/lane-swimming.7e9bbe0adfbff357888e240569125812.svg";
export { ForwardRef as ReactComponent };